import { useCallback } from "react"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { clearSelectedMapIcon } from "features/map/control/slice"
import { MapIconsLabelContent } from "themes/default-tailwind/plugins/map-icons/MapIconsLabelContent"
import { ModalContainerComponent } from "./types"
import { useMapControl } from "features/map/control/useMapControl"
import { selectSelectedMapIcon } from "features/map/control/selectors"
import { resetOverlayAction } from "features/content-overlay/slice"

export const MapIconLabelModal = () => {
    const dispatch = useAppDispatch()
    const { project } = useMapControl()
    const icon = useAppSelector(selectSelectedMapIcon)

    const closeModalHandler = useCallback(() => {
        dispatch(resetOverlayAction())
        dispatch(clearSelectedMapIcon())
    }, [dispatch])

    const deleteClickHandler = useCallback(() => {
        // dispatch(deleteMapIcon({ id: icon.id, fireId: icon.fireId }))
        closeModalHandler()
    }, [closeModalHandler])

    if (!icon) return null

    const xyCoordinates = project([icon.longitude, icon.latitude])

    return (
        <MapIconsLabelContent
            clickHandler={deleteClickHandler}
            onClose={closeModalHandler}
            name={icon.name}
            x={xyCoordinates[0]}
            y={xyCoordinates[1]}
        />
    )
}

export default MapIconLabelModal as ModalContainerComponent
